import { ReactEditor } from 'slate-react';

import * as blocks from '../blocks';
import { onKeyDown as confettiHandler } from '../confetti';
import { onKeyDown as customBlocksMenuHandler } from '../CustomBlocksMenu';
import { onKeyDown as emojiMenuHandler } from '../EmojiMenu';
import leaves from '../leaves';
import { onKeyDown as pageMenuHandler } from '../PageMenu';
import { onKeyDown as slashMenuHandler } from '../slashMenu';
import { onKeyDown as variableMenuHandler } from '../VariableMenu';

import arrowHandlers from './arrow';
import backspaceHandlers from './backspace';
import deleteHandlers from './delete';
import enterHandlers from './enter';

const tabOrShiftTab = event => {
  if (event.key === 'Tab') {
    event.preventDefault();
  }
};

const blurOnEscape = (event, editor) => {
  if (event.key === 'Escape') {
    event.preventDefault();
    event.stopPropagation();

    ReactEditor.blur(editor);
  }
};

/*
 * onKeyDown expects handlers to have a prototype of:
 *
 * (event, editor) => void
 * @param {React SyntheticEvent} event
 * @param {Editor} editor
 * @returns {void}
 *
 * Calling event.stopPropagation() will halt 'queueEventHandlers'
 */
const onKeyDown = ({ editor }) => {
  const nodeHandlers = [...Object.values(blocks), ...Object.values(leaves)].reduce((memo, node) => {
    return node.onKeyDown ? memo.concat(node.onKeyDown) : memo;
  }, []);

  const funcs = [
    tabOrShiftTab,
    slashMenuHandler,
    confettiHandler,
    pageMenuHandler,
    customBlocksMenuHandler,
    variableMenuHandler,
    emojiMenuHandler,
    ...nodeHandlers,
    blurOnEscape,
    ...arrowHandlers,
    ...backspaceHandlers,
    ...deleteHandlers,
    ...enterHandlers,
  ];

  return event =>
    funcs.find(fn => {
      fn(event, editor);
      return event.isPropagationStopped();
    });
};

export default onKeyDown;
